import { useEffect } from 'react';
import WebFont from 'webfontloader';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { LocalizationProvider as MuiPickerProvider } from '@mui/x-date-pickers';
import { pdfjs } from 'react-pdf';

import theme from 'core/theme';
import Router from 'core/routing';

import { LocalizationProvider } from 'core/contexts/localization';
import getDatepickerLocale from 'core/locales/getDatepickerLocale';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import AppProvider from 'components/AppProvider';

const App = () => {
    useEffect(() => {
        WebFont.load({
            google: {
                families: ['Mina', 'Mina:bold'],
            },
        });

        pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
    }, []);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <MuiPickerProvider dateAdapter={AdapterDateFns} adapterLocale={getDatepickerLocale()}>
                    <LocalizationProvider>
                        <AppProvider>
                            <Router />
                        </AppProvider>
                        <ToastContainer />
                    </LocalizationProvider>
                </MuiPickerProvider>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

App.displayName = 'App';

export default App;
